module.exports = __webpack_public_path__ + "img/eye.40d1b7ff.svg";